import { Controller } from 'stimulus'
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static targets = ['input']

  connect () {
    const autoNumericOptionsVND = {
      digitGroupSeparator        : ',',
      decimalCharacter           : '.',
      decimalCharacterAlternative: ',',
      currencySymbol             : '\u202fMXN',
      currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
      roundingMethod             : 'D',
      decimalPlaces              : 3,
      selectNumberOnly           : true,
      unformatOnSubmit           : true
    }

    new AutoNumeric(this.inputTarget, autoNumericOptionsVND)
  }
}